export default "__VITE_ASSET__CuXvkJbF__"